var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSenseifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "1920px",
    height: "600px",
    viewBox: "0 0 1920 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 316.3,
    y1: 432.9,
    x2: 355.09999999999997,
    y2: 468,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 324.425,
    y1: 552.8625,
    x2: 302.575,
    y2: 592.1375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 203.4,
    y1: 330.5,
    x2: 170.1,
    y2: 305.79999999999995,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 426.6375,
    y1: 438.9125,
    x2: 470.8625,
    y2: 394.6875,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 434.925,
    y1: 329.48749999999995,
    x2: 397.075,
    y2: 285.3125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 321.1125,
    y1: 319.6875,
    x2: 290.58750000000003,
    y2: 350.2125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 433.0375,
    y1: 214.1875,
    x2: 450.6625,
    y2: 158.5125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 545.35,
    y1: 428.0625,
    x2: 588.65,
    y2: 448.5375,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFBA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_9",
    gradientUnits: "userSpaceOnUse",
    x1: 290.75,
    y1: 712.45,
    x2: 308.54999999999995,
    y2: 688.45,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_10",
    gradientUnits: "userSpaceOnUse",
    x1: 17.862499999999997,
    y1: 368.1875,
    x2: 65.9375,
    y2: 374.3125,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_11",
    gradientUnits: "userSpaceOnUse",
    x1: 254.85,
    y1: 99.1125,
    x2: 293.65,
    y2: 112.28750000000001,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_12",
    gradientUnits: "userSpaceOnUse",
    x1: 612.9499999999999,
    y1: 247.63750000000002,
    x2: 613.65,
    y2: 265.46250000000003,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFDB2C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    stroke: "none",
    d: " M 735.1 475 Q 747.8 478.45 759.5 485.5 L 769.95 459.7 Q 758.5 451.95 742.7 448 726.85 443.85 710.55 443.85 687.1 443.85 670.8 450.95 654.55 458.15 646.6 470.3 643.7478515625 474.54296875 641.9 479.1 638.5 487.57890625 638.5 497.2 638.5 507.9275390625 641.9 515.95 644.0623046875 521.0763671875 647.6 525.1 656.65 535.45 669.25 540.3 682 545.15 702.3 550.05 716.85 553.6 725.35 556.35 733.75 559.25 739.2 564.2 744.65 569.1 744.65 576.8 744.65 587.3 734.95 593.6 725.1 600 705.15 600 689.05 600 673.15 594.5 657.2 589 646.25 580.45 L 634.75 606.1 Q 637.99609375 608.91328125 641.9 611.4 651.5255859375 617.5236328125 665.15 621.65 684.45 627.55 705.15 627.55 728.6 627.55 744.9 620.45 761.25 613.35 769.35 601.35 777.45 589.25 777.45 574.55 777.45 557.15 768.35 546.9 759.25 536.7 746.55 531.7 733.75 526.85 713.9 522.25 699.3 518.6 690.85 515.7 682.5 513.05 677 508.15 671.5 503.25 671.5 495.65 671.5 484.7 681 478 690.6 471.35 710.3 471.35 722.25 471.35 735.1 475 M 1229.15 475 Q 1241.85 478.45 1253.55 485.5 L 1264 459.7 Q 1252.55 451.95 1236.75 448 1220.9 443.85 1204.6 443.85 1181.15 443.85 1164.85 450.95 1148.6 458.15 1140.65 470.3 1132.55 482.35 1132.55 497.2 1132.55 514.75 1141.65 525.1 1150.7 535.45 1163.3 540.3 1176.05 545.15 1196.35 550.05 1210.9 553.6 1219.4 556.35 1227.8 559.25 1233.25 564.2 1238.7 569.1 1238.7 576.8 1238.7 587.3 1229 593.6 1219.15 600 1199.2 600 1183.1 600 1167.2 594.5 1151.25 589 1140.3 580.45 L 1128.8 606.1 Q 1140.05 615.85 1159.2 621.65 1178.5 627.55 1199.2 627.55 1222.65 627.55 1238.95 620.45 1255.3 613.35 1263.4 601.35 1271.5 589.25 1271.5 574.55 1271.5 557.15 1262.4 546.9 1253.3 536.7 1240.6 531.7 1227.8 526.85 1207.95 522.25 1193.35 518.6 1184.9 515.7 1176.55 513.05 1171.05 508.15 1165.55 503.25 1165.55 495.65 1165.55 484.7 1175.05 478 1184.65 471.35 1204.35 471.35 1216.3 471.35 1229.15 475 M 965.95 488.7 L 965.95 625.05 997.85 625.05 997.85 556.1 Q 997.85 536.15 1008.05 525.6 1018.3 515 1035.85 515 1051.45 515 1059.95 524.1 1068.25 533.2 1068.25 551 L 1068.25 625.05 1100.2 625.05 1100.2 546.9 Q 1100.2 517.4 1084.6 502.3 1069 487.2 1043.2 487.2 1028.25 487.2 1016.2 492.05 1004.25 496.95 996.35 506.4 L 996.35 488.7 965.95 488.7 M 842.6 591 Q 830.65 582.15 827.9 567.1 L 934.8 567.1 Q 935.3 560.95 935.3 557.65 935.3 536.7 926.5 520.75 917.75 504.8 902.1 496.05 886.35 487.2 866.45 487.2 846.25 487.2 830.15 496.15 814.1 505.05 805.1 520.95 796 536.95 796 556.85 796 577.05 805.35 593.05 814.55 608.95 831.8 617.95 848.85 626.8 871.3 626.8 888.85 626.8 902.9 621.15 917.05 615.6 926.1 604.6 L 909.05 584.9 Q 894.5 599.75 872.05 599.75 854.5 599.75 842.6 591 M 827.65 545.9 Q 829.9 530.8 840.5 521.85 851.1 512.75 866.45 512.75 882 512.75 892.45 522 902.9 531.05 904.9 545.9 L 827.65 545.9 M 1728.2 488.7 L 1696.3 488.7 1696.3 625.05 1728.2 625.05 1728.2 488.7 M 1726.95 433.25 Q 1721.1 428 1712.35 428 1703.65 428 1697.8 433.5 1691.95 439 1691.95 447.2 1691.95 455.35 1697.8 460.75 1703.65 466.25 1712.35 466.25 1721.35 466.25 1727.1 460.55 1732.8 454.8 1732.8 446.3 1732.8 438.45 1726.95 433.25 M 1324.2 496.15 Q 1308.15 505.05 1299.15 520.95 1290.05 536.95 1290.05 556.85 1290.05 577.05 1299.4 593.05 1308.6 608.95 1325.85 617.95 1342.9 626.8 1365.35 626.8 1382.9 626.8 1396.95 621.15 1411.1 615.6 1420.15 604.6 L 1403.1 584.9 Q 1388.55 599.75 1366.1 599.75 1348.55 599.75 1336.65 591 1324.7 582.15 1321.95 567.1 L 1428.9 567.1 Q 1429.35 560.95 1429.35 557.65 1429.35 536.7 1420.55 520.75 1411.8 504.8 1396.15 496.05 1380.4 487.2 1360.5 487.2 1340.3 487.2 1324.2 496.15 M 1321.7 545.9 Q 1323.95 530.8 1334.55 521.85 1345.15 512.75 1360.5 512.75 1376.05 512.75 1386.5 522 1396.95 531.05 1398.95 545.9 L 1321.7 545.9 M 1570 528.55 L 1570 474.25 1667.2 474.25 1667.2 446.3 1536.85 446.3 1536.85 625.05 1570 625.05 1570 556.6 1656.25 556.6 1656.25 528.55 1570 528.55 M 1491.9 488.7 L 1460 488.7 1460 625.05 1491.9 625.05 1491.9 488.7 M 1490.65 433.25 Q 1484.8 428 1476.1 428 1467.35 428 1461.5 433.5 1455.65 439 1455.65 447.2 1455.65 455.35 1461.5 460.75 1467.35 466.25 1476.1 466.25 1485.05 466.25 1490.8 460.55 1496.55 454.8 1496.55 446.3 1496.55 438.45 1490.65 433.25 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cross_0_Layer1_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB2C",
    stroke: "none",
    d: " M 376.65 569.25 L 397.05 589.65 Q 397.15 589.75 397.25 589.85 405.8 598.4 405.8 610.45 405.8 622.55 397.25 631.1 388.75 639.65 376.65 639.65 366.6048828125 639.65 359 633.7 L 279.45 715 Q 320.203125 753.2 376.65 753.2 435.8 753.2 477.55 711.35 519.45 669.5 519.45 610.35 519.45 555.3 483.1 515.2 L 456.85 489.05 376.65 569.25 M 113.55 376.6 Q 113.55 365.028515625 121.4 356.65 L 41.1 276.35 Q 0 318.0302734375 0 376.6 0 435.75 41.85 477.5 83.7 519.4 142.85 519.4 197.9 519.4 238 483.05 L 264.15 456.8 183.95 376.6 163.55 397 Q 163.45 397.1 163.35 397.2 154.8 405.75 142.75 405.75 130.65 405.75 122.1 397.2 113.55 388.7 113.55 376.6 M 376.65 113.55 Q 385.4154296875 113.55 392.3 118.05 L 477 41.2 Q 435.3 0 376.65 0 317.5 0 275.75 41.85 233.85 83.7 233.85 142.85 233.85 197.9 270.2 238 L 296.45 264.15 376.65 183.95 356.25 163.55 Q 356.15 163.45 356.05 163.35 347.5 154.8 347.5 142.75 347.5 130.65 356.05 122.1 364.55 113.55 376.65 113.55 M 753.3 376.6 Q 753.3 317.45 711.45 275.7 669.6 233.8 610.45 233.8 555.4 233.8 515.3 270.15 L 489.15 296.4 569.35 376.6 589.75 356.2 Q 589.85 356.1 589.95 356 598.5 347.45 610.55 347.45 622.65 347.45 631.2 356 639.75 364.5 639.75 376.6 639.75 386.4412109375 634.05 393.95 L 717.35 471.35 Q 753.3 431.3642578125 753.3 376.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: " M 264.15 456.8 L 296.85 489.5 376.65 569.25 456.85 489.05 377.3 409.4 344.4 376.6 264.15 456.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_2)",
    stroke: "none",
    d: " M 296.85 489.5 L 296.3 488.95 272.3 512.9 Q 272 513.2 271.8 513.45 233.85 554.05 233.85 610.35 233.85 669.5 275.65 711.35 277.530859375 713.2287109375 279.45 715 L 359 633.7 Q 357.47265625 632.52265625 356.05 631.1 347.5 622.55 347.5 610.45 347.5 598.4 356.05 589.85 356.25 589.65 356.45 589.45 L 376.65 569.25 296.85 489.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_3)",
    stroke: "none",
    d: " M 41.85 275.6 Q 41.474609375 275.9759765625 41.1 276.35 L 121.4 356.65 Q 121.760546875 356.339453125 122.1 356 130.65 347.45 142.75 347.45 154.8 347.45 163.35 356 163.55 356.2 163.75 356.4 L 183.95 376.6 263.75 296.8 264.3 296.25 240.3 272.25 Q 240 271.95 239.75 271.75 199.15 233.8 142.85 233.8 83.7 233.8 41.85 275.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_4)",
    stroke: "none",
    d: " M 569.35 376.6 L 489.15 296.4 408.95 376.65 376.7 408.75 377.3 409.4 456.85 489.05 489.55 456.35 569.35 376.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_5)",
    stroke: "none",
    d: " M 376.65 344.35 L 408.95 376.65 489.15 296.4 457.05 264.3 376.65 183.95 296.45 264.15 376.65 344.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_6)",
    stroke: "none",
    d: " M 344.4 376.6 L 376.65 344.35 296.45 264.15 263.75 296.8 183.95 376.6 264.15 456.8 344.4 376.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_7)",
    stroke: "none",
    d: " M 477.65 41.85 Q 477.3310546875 41.5314453125 477 41.2 L 392.3 118.05 Q 394.9193359375 119.7693359375 397.25 122.1 405.8 130.65 405.8 142.75 405.8 154.8 397.25 163.35 397.05 163.55 396.85 163.75 L 376.65 183.95 457.05 264.3 481 240.3 Q 481.3 240 481.5 239.75 519.45 199.15 519.45 142.85 519.45 83.7 477.65 41.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_8)",
    stroke: "none",
    d: " M 711.45 477.6 Q 714.5203125 474.5259765625 717.35 471.35 L 634.05 393.95 Q 632.7671875 395.6328125 631.2 397.2 622.65 405.75 610.55 405.75 598.5 405.75 589.95 397.2 589.75 397 589.55 396.8 L 569.35 376.6 489.55 456.35 489 456.95 513 480.95 Q 513.3 481.25 513.55 481.45 554.15 519.4 610.45 519.4 669.6 519.4 711.45 477.6 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cross_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_9)",
    stroke: "none",
    d: " M 275.65 711.35 Q 277.530859375 713.2287109375 279.45 715 320.203125 753.2 376.65 753.2 403.496484375 753.2 426.75 744.55 L 241.05 564.15 Q 233.85 585.765234375 233.85 610.35 233.85 669.5 275.65 711.35 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_10)",
    stroke: "none",
    d: " M 41.85 275.6 Q 41.474609375 275.9759765625 41.1 276.35 0 318.0302734375 0 376.6 0 435.75 41.85 477.5 68.172265625 503.8537109375 101.35 513.6 L 91.4 242.9 Q 64.1697265625 253.30703125 41.85 275.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_11)",
    stroke: "none",
    d: " M 275.75 41.85 Q 233.85 83.7 233.85 142.85 233.85 197.9 270.2 238 L 278.6 246.35 372.7 0.05 Q 316.0947265625 1.4087890625 275.75 41.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_12)",
    stroke: "none",
    d: " M 730.95 299.4 Q 722.71015625 286.933203125 711.45 275.7 669.6 233.8 610.45 233.8 555.4 233.8 515.3 270.15 L 498.6 286.9 730.95 299.4 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1.275634765625, 0, 0, 1.275634765625, -322.5,-389.4) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_FILL"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.572723388671875, 0, 0, 0.572723388671875, 32.15,84.3) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cross_0_Layer1_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cross_0_Layer0_0_FILL"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenseifi);
export default __webpack_public_path__ + "static/media/senseifi.f832d5333a155ba7a4381f7e4069aa6c.svg";
export { ForwardRef as ReactComponent };